// src/admin/pages/KPI/components/kpi/PerformanceSection.js
import React from "react";
import { useMediaQuery } from "react-responsive";
import KPICard from "./KPICard";

/* ------------------------------------------------------------------
   Helpers di formattazione
------------------------------------------------------------------ */
const fmtCur = (v) =>
  typeof v === "number" && !Number.isNaN(v) ? `€ ${v.toFixed(2)}` : "€ 0.00";
const fmtPct = (v) =>
  typeof v === "number" && !Number.isNaN(v) ? `${v.toFixed(1)}%` : "0.0%";

/**
 * PerformanceSection
 *
 * Props:
 *  - kpis         → oggetto KPI
 *  - onCardClick? → handler(cardKey) per aprire il trend
 */
export default function PerformanceSection({ kpis, onCardClick }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (!kpis) return null;

  const revenue    = kpis.total_revenue         ?? 0;
  const costIngred = kpis.total_ingredient_cost ?? 0;
  const costExtra  = kpis.total_overhead_cost   ?? 0;

  const margin     = revenue - costIngred;
  const marginPct  = revenue > 0 ? (margin / revenue) * 100 : 0;
  const markupPct  = costIngred > 0 ? (margin / costIngred) * 100 : 0;
  const netProfit  = margin - costExtra;
  const profitPct  = revenue > 0 ? (netProfit / revenue) * 100 : 0;

  return (
    <div style={grid(isMobile)}>
      <KPICard
        title="Margine Netto"
        value={fmtCur(margin)}
        description="Revenue - Costo ingredienti"
        onClick={() => onCardClick?.("margin_net")}
      />
      <KPICard
        title="Margine %"
        value={fmtPct(marginPct)}
        description="(Margine / Revenue) × 100"
        onClick={() => onCardClick?.("margin_pct")}
      />
      <KPICard
        title="Markup %"
        value={fmtPct(markupPct)}
        description="(Margine / Costi ingredienti) × 100"
        onClick={() => onCardClick?.("markup_pct")}
      />
      <KPICard
        title="Profitto Netto"
        value={fmtCur(netProfit)}
        description="Margine Netto - Costi Extra"
        onClick={() => onCardClick?.("net_profit")}
      />
      <KPICard
        title="Profitto %"
        value={fmtPct(profitPct)}
        description="(Profitto Netto / Revenue) × 100"
        onClick={() => onCardClick?.("profit_pct")}
      />
    </div>
  );
}

/* ------------------------------------------------------------------
   griglia responsive
------------------------------------------------------------------ */
const grid = (isMobile) => ({
  display: "grid",
  gap: "1rem",
  marginTop: "1rem",
  gridTemplateColumns: isMobile
    ? "repeat(auto-fill, minmax(160px, 1fr))"
    : "repeat(auto-fill, minmax(200px, 1fr))",
});
